import * as React from 'react';

const SLOW_LOAD_HINT_MS = 15000;

// Branded full-screen splash shown while the app boots (authenticating,
// loading services, lazy-loading the App chunk). Styling lives in
// public/index.html so the pre-React #app-loading shell shares the exact same
// classes and there is no visual flash when React takes over.
//
// Strings are intentionally hardcoded English: this renders before
// registerServices completes, so i18n is not initialized yet.
export const AppSplashScreen = ({ status }) => {

    const [showSlowHint, setShowSlowHint] = React.useState(false);

    // The static #app-loading splash sits after #root in the DOM, so while both
    // are visible it would cover this one and the phase-aware status text would
    // never show. Hide it as soon as any React splash commits. App.js hides it
    // again when the real app mounts, which also covers direct App renders.
    React.useLayoutEffect(() => {
        const staticSplash = document.getElementById('app-loading');
        if (staticSplash) {
            staticSplash.hidden = true;
        }
    }, []);

    React.useEffect(() => {

        setShowSlowHint(false);

        const timeoutID = setTimeout(() => setShowSlowHint(true), SLOW_LOAD_HINT_MS);

        return () => clearTimeout(timeoutID);

    }, [status]);

    return (
        <div className="app-splash">
            <div className="app-splash-wordmark" aria-hidden="true">INSYTE</div>
            <div className="app-splash-center">
                <div className="app-splash-status" role="status" aria-live="polite">
                    {status}
                    <span className="app-splash-dots"><span /><span /><span /></span>
                </div>
                <div className="app-splash-track"><i /></div>
                <div className="app-splash-hint">
                    {showSlowHint ? 'This is taking longer than usual \u2014 check your connection, or refresh to try again.' : ''}
                </div>
            </div>
        </div>
    );
};
